






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { maskDate } from '@/utils/common'

@Component
export default class TaxaAluguelParametrosDataTable extends Vue {
  @Prop({ default: 1 }) pagina!: number
  @Prop({ default: 10 }) qtdPorPagina!: number

  loadParametrosAplicacao: boolean = false
  loadingDeleteParametroAplicacao: string = ''
  parametrosAplicacaoHeaders = [
    { text: 'Fonte Pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Prestador', value: 'nomePrestador', sortable: false },
    { text: 'Centro de custo', value: 'centroDeCusto', sortable: false },
    { text: 'Criado por', value: 'usuarioCriacao', sortable: false },
    { text: 'Criado em', value: 'createdOn', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false }
  ]

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get configsParametrosAplicacao() {
    return this.getFinanceiroStore.configsParametrosAplicacao
  }

  get fontesPagadoras() {
    return this.getFinanceiroStore.fontePagadoras || []
  }

  get prestadores() {
    return this.getFinanceiroStore.prestadoresLista.slice(1) || []
  }

  get fontePagadoraFiltro() {
    return this.getFinanceiroStore.parametrosAplicacaoTaxaAluguelFontePagadoraId
  }

  set fontePagadoraFiltro(value: string) {
    this.getFinanceiroStore.setParametrosAplicacaoTaxaAluguelFontePagadoraId(value || '')
  }

  get prestadorFiltro() {
    return this.getFinanceiroStore.parametrosAplicacaoTaxaAluguelPrestadorId
  }

  set prestadorFiltro(value: string) {
    this.getFinanceiroStore.setParametrosAplicacaoTaxaAluguelPrestadorId(value || '')
  }

  get loadingParametrosAplicacao() {
    return this.loadParametrosAplicacao
  }

  set loadingParametrosAplicacao(value: boolean) {
    this.loadParametrosAplicacao = value
  }

  editarParametros(parametros: any) {
    const item = {
      id: parametros.id,
      fontePagadoraId: parametros.fontePagadoraId,
      prestadorId: parametros.prestadorId,
      centroDeCustoId: parametros.centroDeCustoId,
    }

    this.getFinanceiroStore.setItemParametroAplicacaoTaxaAluguel(item)
    this.getFinanceiroStore.setOriginalItemParametroAplicacaoTaxaAluguel(item)
    this.$emit('edit-parametro-aplicacao')
    this.showModalCriarParametroAplicacao()
  }

  async deletarParametros(id: string) {
    this.loadingDeleteParametroAplicacao = id
    const request = await this.getFinanceiroStore.deletarParametroAplicacaoTaxaAluguel(id)

    if (request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Parâmetro removido com sucesso!',
        icon: 'done',
        color: '#2E7D32',
      })
      this.$emit('refresh-parametros-aplicacao')
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text:
          request.message ||
          'Ocorreu um erro ao remover o parâmetro de aplicação.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingDeleteParametroAplicacao = ''
  }

  showModalCriarParametroAplicacao() {
    this.getFinanceiroStore.setModal({
      name: 'criarParametrosAplicacao',
      value: true,
    })
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async buscarParametrosAplicacaoComFiltro() {
    this.loadingParametrosAplicacao = true

    this.getFinanceiroStore.setParametrosAplicacaoTaxaAluguelPagina(1)
    await this.getFinanceiroStore.getParametrosAplicacaoTaxaAluguel()
    this.$emit('update:pagina', 1)
    this.loadingParametrosAplicacao = false
  }

}
